import axios from 'axios';
import { debounce } from 'lodash/fp';

import actionTypes from './index';
import config from '../../helpers/config';

const getSpecs = dispatch => axios.get(`${config.newMandiBaseUrl}/api/jobs/specs`)
  .then(res => dispatch({
    type: actionTypes.SPEC_MAPPINGS,
    payload: res.data,
  }));
const limitGetSpecs = debounce([10000, { leading: true }], getSpecs);
export default () => limitGetSpecs;
